/**
 * Product DTO for put and post requests
 */
export class ProductRequestDTO {
  /**
   * @constructor
   */
  constructor(
    public name?: string,
    public headers?: string[],
    public image?: string,
    public family?: string,
    public rewardsQuantity?: number,
    public familyId?: number
  ) {}
}
